var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSaveP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_139_3",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_139_3",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACSUlEQVR4nO2cvU5bQRCFtwpI4QkAiXjHCNgldmfoqJC8cyU63oKfEsqUKUkeKojKyTPkCSKQgMpoRUORKFxbd2fu7Pmkrfecz+Ox3KxzAAAAAAAAAAAAAMBtbR2tRp8uI6W74PkhEs//d1wHtL3r3/nSF3Uf6+fhdDMQ/3qP3P6IZl2y8yQvIjn2QrQi2a/ror3k2BvRSmTnnWxfNMvLjp7v6xDNWfZXJ8WikmMvRQvKrk80y8iuUzSXl12vaC4ru27RXE42RHMZ2RDNnX07IZrKrEGIJohuzfI/hpVOdFsguhBViN7ZOVl3goy3m40qRAffXDlBgufrKkRHn56z7NKTne/L9+b76xBNdg5EE0TPpacQE03y4rA6SF4qdjRBtPjERUw0i0vC6iB5gdjRpOvgDwtB9Fx6CjHRJC8Oq4PkpWJHE0T/bQoeA/FNGDST0ej4oxMi3723zQeB0rfo+cnURAfPv/cH05FTRvzUjHM2K6IfNUp+K3uRye4+WNtpJr5xyok+fe+/6EEzccrZHU4P+y86HK055eSMvRftekLU1ktdIKu91AWy2ktdIKu91AWy2ktdIKu91AWy2ktdIKu91AWy2ktdIKu91AWy2ktdIKu91AWy2ktdIKu91AWy2ktdIKu91AWy2ktdIKu9lnmOLVo5nv+ofmAwWjmebzsXve/5QrwoyZ5A6axz0cPhdCVQ+lnvNKdZCKcfXLlnjSuU7dMsv5DgSvI62Xye95XpH0jP98GnH3ldFJtkAAAAAAAAAAAAAKebF3Myq53JPKgkAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSaveP);
export default __webpack_public_path__ + "static/media/ic_saveP.60ac660ed4662f64272061f1de8d29f4.svg";
export { ForwardRef as ReactComponent };